import {
  pathOr,
} from 'ramda'
import axios from 'axios'
import queryString from 'query-string'
import URLSearchParams from 'url-search-params'

import setBasket, {
  setBasketState,
  BASKET_FAILED,
  BASKET_LOADED,
  BASKET_LOADING,
} from './setBasketState'

import { IsDev } from '../../../helpers/build'
import toggleGlobalLoader from '../../loader/actions/loaderActions'
import { SEARCH_PARAM_ROOM, SEARCH_PARAM_APARTMENT_ID } from '../../search/constants'
import openPopup, { closePopup } from '../../PopupConstructor/actions/popupActions'
import {
  GLOBAL_ERROR_POPUP,
  MULTIPLE_CONFIRMATION
} from '../../PopupConstructor/constants'
import mockedData from './mockBasket'
import {cleanUrlParam} from 'js/helpers/urlHelpers'
import setOptionsValue from '../../firstStepRedesign/actions/setOptionsValue';

const BASKET_API_URL = pathOr('https://5b3a1a5a356f570014d0baa0.mockapi.io/basket', 'drupalSettings.basket.url'.split('.'), window)

const postBasket = async (dispatch, getState, params, callbacks = {}) => {
  const {
    onResponse,
    onErrorSubmit
  } = callbacks
  dispatch(toggleGlobalLoader(true))
  const url = BASKET_API_URL

  const cleanSearchQuery = cleanUrlParam(window.location.search)
  const currentQueryParams = queryString.parse(cleanSearchQuery, { arrayFormat: 'bracket' })
  const paramsToSend = {
    ...params,
    query: currentQueryParams,
  }

  dispatch(setBasketState(BASKET_LOADING))

  try {

    let data = mockedData
    if (IsDev) {
      console.info('%c POST /basket, paramsToSend: ', 'color: #67a9ad; font-weight: bold;', paramsToSend)
    } else {
      data = pathOr({}, ['data'], await axios.post(url, paramsToSend))
      if (onResponse) {
        onResponse(data)
      }
    }

    if (!window.basketExpCheck) {
      window.basketExpCheck = setInterval(() => {
        const currDate = parseInt(new Date().getTime() / 1000, 10)
        const expiration = pathOr({}, ['main', 'basket', 'expiration'], getState())
        const {
          expire, title, description, linkTitle, linkUrl,
        } = expiration

        if (expire < currDate) {
          const errData = {
            message: {
              type: 'basketExpired',
              title,
              description,
              link: {
                title: linkTitle,
                url: linkUrl,
              },
            },
          }
          dispatch(openPopup(GLOBAL_ERROR_POPUP, errData))
          clearInterval(window.basketExpCheck)
        }
      }, 1000 * 60)
    }

    const searchParams = new URLSearchParams(window.location.search)
    const apartmentParamArr = searchParams.getAll(SEARCH_PARAM_ROOM).map(param => param.split(',')[3])
    const activeApartmentId = searchParams.get(SEARCH_PARAM_APARTMENT_ID)

    const state = getState()
    const searchRooms = pathOr([], ['form', 'searchFilters', 'rooms'], state)
    const basketApartments = pathOr([], ['main', 'basket', 'apartments'], state)
    const basketButtonUrl = pathOr('#', ['main', 'basket', 'button', 'url'], state)
    const isLessThanLarge = pathOr(false, ['browser', 'lessThan', 'large'], state)

    if (
      searchRooms.length > 1
      && searchRooms.length === data.apartments.length
      && data.apartments.length !== basketApartments.length
      && isLessThanLarge
    ) {
      if (apartmentParamArr.length) {
        searchParams.set(SEARCH_PARAM_APARTMENT_ID, apartmentParamArr[0])
      }
      if (pathOr(null, ['drupalSettings', 'rooms', 'multipleConfirmation'], window)) {
        dispatch(openPopup(MULTIPLE_CONFIRMATION, {
          redirectFunc: () => { dispatch(closePopup()) },
          bookFunction: () => {
            window.location.href = basketButtonUrl
            dispatch(closePopup())
          },
        }))
      }
    }

    dispatch(setBasketState(BASKET_LOADED))
    dispatch(setBasket(data))
    dispatch(toggleGlobalLoader(false))

  } catch (e) {
    const data = pathOr({}, ['response', 'data'], e)
    const dataToSend = { ...data }
    if (data.message) {
      const redirectUrl = data?.['url_redirect']
      if (redirectUrl) dataToSend.onCloseFunc = (close) => {
        close()
        window.location.replace(redirectUrl)
      }

      if (onErrorSubmit) {
        dataToSend.onSubmitFunc = function (e, onClose) {
          onErrorSubmit(data, paramsToSend, onClose)
        }
      }

      dispatch(openPopup(GLOBAL_ERROR_POPUP, dataToSend))
    }

    dispatch(setBasketState(BASKET_FAILED))
    dispatch(toggleGlobalLoader(false))
  }
}

export default
(params, callbacks) => (dispatch, getState) => postBasket(dispatch, getState, params, callbacks)
